// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import displayOrder from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { generateLinksFrom } from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import constants from "@store/constants";
import getOrderChangeRequestAvailability from "@store/Framework/Common/Utilities/OrderChangeRequest/getOrderChangeRequestAvailability";
import OrderChangeUnavailableAlert from "@store/Library/Components/OrderChangeRequest/OrderChangeUnavailableAlert";
import getQueryString from "@toolkit/Framework/Common/Utilities/getQueryString";
import { useCurrentPage, useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { useHomePageUrl, usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useEffect, useMemo } from "react";

export interface OrderChangeRequestPageProps extends PageProps {}

export interface OrderChangeRequestPageStyles {}

export const orderChangeRequestPageStyles: OrderChangeRequestPageStyles = {};

const styles = orderChangeRequestPageStyles;

const OrderChangeRequestPage: FC<OrderChangeRequestPageProps> = ({ id }) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const homePageUrl = useHomePageUrl();
    const orderNumber = useMemo(() => {
        return location.search ? getQueryString(location.search).orderNumber : undefined;
    }, [location.search]);
    const orderState = useAppSelector(state => getOrderState(state, orderNumber));
    const links = useAppSelector(state => state.links);
    const { nodeId } = useCurrentPage();
    const orderDetailsLink = usePageLinkByPageType(constants.pageType.orderDetails);
    const breadcrumbLinks = useAppSelector(state => state.components.breadcrumbs.links);

    useEffect(() => {
        if (orderNumber && !orderState?.value && !orderState?.isLoading) {
            dispatch(displayOrder({ orderNumber }));
        }

        return () => {
            dispatch(setBreadcrumbs({ links: undefined }));
        };
    }, []);

    useEffect(() => {
        if (!links.areLinksLoading && !breadcrumbLinks && orderNumber) {
            const breadcrumbs = generateLinksFrom(links, nodeId, homePageUrl);

            breadcrumbs.some(link => {
                if (link.children === orderDetailsLink?.title) {
                    link.href += `?orderNumber=${orderNumber}`;
                    return true;
                }

                return false;
            });

            dispatch(setBreadcrumbs({ links: breadcrumbs }));
        }
    }, [breadcrumbLinks, links, orderNumber, nodeId, homePageUrl, orderDetailsLink]);

    const { canRequestOrderChange } = getOrderChangeRequestAvailability(orderState?.value);

    return (
        <Page>
            <OrderStateContext.Provider value={orderState}>
                {canRequestOrderChange ? <Zone contentId={id} zoneName="Content" /> : <OrderChangeUnavailableAlert />}
            </OrderStateContext.Provider>
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: OrderChangeRequestPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
